var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRoundUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.75C7.39137 2.75 3.25 6.89137 3.25 12C3.25 13.4811 3.59753 14.8788 4.2148 16.1181C4.46254 16.6155 4.55794 17.2103 4.40163 17.7945L3.80602 20.0205C3.69663 20.4293 4.07066 20.8034 4.47949 20.694L6.70553 20.0984C7.28973 19.9421 7.88451 20.0375 8.38191 20.2852C9.62121 20.9025 11.0189 21.25 12.5 21.25C17.6086 21.25 21.75 17.1086 21.75 12C21.75 11.3655 21.6862 10.7466 21.565 10.1492C21.4826 9.74326 21.7448 9.34739 22.1508 9.26499C22.5567 9.18259 22.9526 9.44487 23.035 9.8508C23.1761 10.5458 23.25 11.2647 23.25 12C23.25 17.9371 18.4371 22.75 12.5 22.75C10.7817 22.75 9.15552 22.3463 7.71315 21.6279C7.49791 21.5207 7.27813 21.4979 7.09324 21.5474L4.8672 22.143C3.34337 22.5507 1.94927 21.1566 2.357 19.6328L2.9526 17.4068C3.00208 17.2219 2.97933 17.0021 2.87213 16.7869C2.15371 15.3445 1.75 13.7183 1.75 12C1.75 6.06294 6.56294 1.25 12.5 1.25C13.2353 1.25 13.9541 1.32394 14.6492 1.46503C15.0551 1.54743 15.3174 1.9433 15.235 2.34924C15.1526 2.75517 14.7567 3.01745 14.3508 2.93505C13.7534 2.81378 13.1345 2.75 12.5 2.75ZM15.75 5C15.75 2.92893 17.4289 1.25 19.5 1.25C21.5711 1.25 23.25 2.92893 23.25 5C23.25 7.07107 21.5711 8.75 19.5 8.75C17.4289 8.75 15.75 7.07107 15.75 5ZM19.5 2.75C18.2574 2.75 17.25 3.75736 17.25 5C17.25 6.24264 18.2574 7.25 19.5 7.25C20.7426 7.25 21.75 6.24264 21.75 5C21.75 3.75736 20.7426 2.75 19.5 2.75Z",
    fill: "#1E2D66",
    stroke: "#1E2D66",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRoundUnread);
export default __webpack_public_path__ + "static/media/Chat_Round_Unread.a623e673b6803a42e2a99db990cfb124.svg";
export { ForwardRef as ReactComponent };